import type { Options as YoutubePlayerOptions } from "youtube-player/dist/types";

export const getPlayerOptions = ({
  adIu,
  enableAutoPlay,
  height,
  isEnabledImaManager,
  relatedChannels,
  width,
}: {
  adIu: string;
  enableAutoPlay: boolean;
  height?: number | string;
  isEnabledImaManager?: boolean;
  relatedChannels: string[];
  width?: number | string;
}): YoutubePlayerOptions => ({
  embedConfig: {
    adsConfig: {
      adTagParameters: {
        iu: adIu,
      },
      disableAds: true,
      nonPersonalizedAd: true,
    },
    disabledRelatedVideos: true,
    enableIma: true,
    relatedChannels,
  },
  height,
  playerVars: {
    // https://developers.google.com/youtube/player_parameters
    autoplay: enableAutoPlay ? 1 : 0,
    fs: isEnabledImaManager ? 0 : 1, // Turn off the fullscreen button when IMA is enabled to avoid youtube and IMA players switch exit fullscreen issue
    origin: window.location.origin,
    playsinline: 1,
    rel: 0,
  },
  width,
});
